/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {MonkeysGoldServerDataParser} from "../MonkeysGoldServerDataParser";
import {IMonkeysGoldGameData} from "./IMonkeysGoldServerData";
import {AvalancheParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheParsedServerData";
import {IExistingBigSymbols} from "./IExistingBigSymbols";

export class MonkeysGoldParsedGameData extends AvalancheParsedGameData {
    public get accumulatedRoundWin(): string {
        return this._accumulatedRoundWin;
    }
    private readonly _numberOfUpgrades:number;
    private readonly _reelsAfterCollapseUpgraded:string[][];
    private readonly _upgradePositionsAfterCollapse:boolean[][];
    private readonly _allNewWinPositions:boolean[][];
    private readonly _completeRowsArray:number[];
    private readonly _bigOverlaySymbol:string[][];
    private readonly _existingBigSymbols:IExistingBigSymbols[];
    private readonly _bigSymbolsAfterSpin:IExistingBigSymbols[];
    private readonly _bigSymbolPosition:number[];
    private readonly _bigSymbolSize:number;
    private readonly _bigSymbolMultiplier:number;
    private readonly _bigSymbolFinalMultiplier:number;
    private readonly _avalancheCountThisSpinBefore:number;
    private readonly _avalancheCountThisSpinAfter:number;
    private readonly _upgrade2x2Symbols:boolean[][];
    private readonly _upgrade3x3Symbols:boolean[][];
    private readonly _fsMultiplierBefore:number;
    private readonly _fsMultiplierAfter:number;
    private readonly _fsMultiplierIncrease:number;
    private readonly _avalancheSymbolHighlight:boolean[][];
    private readonly _accumulatedRoundWin:string;


    //No win
    //[["L4","L3","M4","M1","M2","M3"],["M3","M2","M4","L1","L2","L4"],["L1","L3","L2","M1","L3","L2"],["L3","L1","M3","M2","L1","L4"],["L2","L3","M2","M3","L4","L2"],["L3","L1","M3","M2","L2","L4"]]

    constructor(rawData:IMonkeysGoldGameData, dataParser:MonkeysGoldServerDataParser) {
        dataParser.parseReelData(rawData);
        super(rawData, dataParser);
        this._numberOfUpgrades = rawData.numberOfUpgrades;
        this._reelsAfterCollapseUpgraded = rawData.reelsAfterCollapseUpgraded;
        this._upgradePositionsAfterCollapse = rawData.upgradePositionsAfterCollapse;
        this._allNewWinPositions = dataParser.parseNewWinPositions(rawData);
        this._completeRowsArray = dataParser.parseWinRow(rawData);
        this._bigOverlaySymbol = rawData.bigOverlaySymbol;
        this._existingBigSymbols = dataParser.parseExistingBigSymbols(rawData);
        this._bigSymbolsAfterSpin = dataParser.parseBigSymbolsAfterSpin(rawData);
        this._upgrade2x2Symbols = dataParser.parseUpgrade2x2Symbols(rawData);
        this._upgrade3x3Symbols = dataParser.parseUpgrade3x3Symbols(rawData);
        this._bigSymbolPosition = rawData.bigSymbolPosition;
        this._bigSymbolSize = rawData.bigSymbolSize;
        this._bigSymbolMultiplier = rawData.bigSymbolMultiplier;
        this._bigSymbolFinalMultiplier = rawData.bigSymbolFinalMultiplier;
        this._numberOfUpgrades = rawData.numberOfUpgrades;
        this._avalancheCountThisSpinBefore = rawData.avalancheCountThisSpinBefore;
        this._avalancheCountThisSpinAfter = rawData.avalancheCountThisSpinAfter;
        this._fsMultiplierAfter = rawData.fsMultiplierAfter;
        this._fsMultiplierBefore = rawData.fsMultiplierBefore;
        this._fsMultiplierIncrease = rawData.fsMultiplierIncrease;
        this._avalancheSymbolHighlight = rawData.avalancheSymbolHighlight;
        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }

    get avalancheSymbolHighlight():boolean[][] {
        return this._avalancheSymbolHighlight;
    }

    get fsMultiplierIncrease():number {
        return this._fsMultiplierIncrease;
    }

    get bigSymbolFinalMultiplier():number {
        return this._bigSymbolFinalMultiplier;
    }

    get fsMultiplierBefore():number {
        return this._fsMultiplierBefore;
    }

    get fsMultiplierAfter():number {
        return this._fsMultiplierAfter;
    }

    get upgrade3x3Symbols():boolean[][] {
        return this._upgrade3x3Symbols;
    }

    get upgrade2x2Symbols():boolean[][] {
        return this._upgrade2x2Symbols;
    }

    get avalancheCountThisSpinBefore():number {
        return this._avalancheCountThisSpinBefore;
    }

    get avalancheCountThisSpinAfter():number {
        return this._avalancheCountThisSpinAfter;
    }

    public get completeRowsArray():number[] {
        return this._completeRowsArray;
    }

    public get upgradePositionsAfterCollapse():boolean[][] {
        return this._upgradePositionsAfterCollapse;
    }

    public get allNewWinPositions():boolean[][] {
        return this._allNewWinPositions;
    }

    public get reelsAfterCollapseUpgraded():string[][] {
        return this._reelsAfterCollapseUpgraded;
    }

    public get numberOfUpgrades():number {
        return this._numberOfUpgrades;
    }

    get bigSymbolsAfterSpin():IExistingBigSymbols[] {
        return this._bigSymbolsAfterSpin;
    }

    get bigOverlaySymbol():string[][] {
        return this._bigOverlaySymbol;
    }

    get existingBigSymbols():IExistingBigSymbols[] {
        return this._existingBigSymbols;
    }

    get bigSymbolPosition():number[] {
        return this._bigSymbolPosition;
    }

    get bigSymbolSize():number {
        return this._bigSymbolSize;
    }

    get bigSymbolMultiplier():number {
        return this._bigSymbolMultiplier;
    }
}